// Modal remove
function openModalRemove(e, is_direct = true, inputElement = undefined) {
  const element = $(e)
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  const qty = element.attr("data-qty");

  if (is_direct) {
    inputElement = $(element.attr('data-id'))
  }
  if (inputElement) {
    elBtnRemoveCart.setAttribute("data-quantity", inputElement.val())
  }

  elBtnRemoveCart.setAttribute("data-id-input", inputElement.attr('id'))

  if (elBtnRemoveCart) {
    elModalRemove.classList.remove('wp-hidden');
    const elPreviewImg = elModalRemove.querySelector('img');
    elPreviewImg.setAttribute('src', element.data("previewImg"));
    elBtnRemoveCart.setAttribute('data-key', element.data("key"));
    const groupKeys = element.attr('data-group-keys') || (inputElement && inputElement.attr && inputElement.attr('data-group-keys'));
    if (groupKeys) {
      elBtnRemoveCart.setAttribute('data-group-keys', groupKeys);
    } else {
      elBtnRemoveCart.removeAttribute('data-group-keys');
    }
  }
}

function closeModalRemove() {
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  const quantity = elBtnRemoveCart.getAttribute('data-quantity');
  const idInput = elBtnRemoveCart.getAttribute('data-id-input');
  const elInput = document.querySelector(`#${idInput}`)
  let itemId = elBtnRemoveCart.dataset.key;
  if (quantity <= 0) {
    const old_value = elInput.getAttribute("data-old-value");
    $(elInput).val(old_value);
  }
  elModalRemove.classList.add('wp-hidden');
  elBtnRemoveCart.removeAttribute('data-key');
  elBtnRemoveCart.removeAttribute('data-group-keys');
}

function removeCart() {
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  let itemId = elBtnRemoveCart.dataset.key;
  const groupKeysRaw = elBtnRemoveCart.getAttribute('data-group-keys');
  elBtnRemoveCart.removeAttribute('data-group-keys');
  elModalRemove.classList.add('wp-hidden');
  if (itemId && groupKeysRaw) {
    removeCartLines([itemId].concat(groupKeysRaw.split(',').filter(Boolean)));
    return;
  }
  callAPIUpdateCartPageCart(0, itemId);
}

function removeCartLines(keys) {
  const updates = {};
  keys.forEach(function (key) {
    if (key) updates[key] = 0;
  });
  if (!Object.keys(updates).length) return;
  showUIBlock();
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: JSON.stringify({ updates: updates }),
    dataType: 'json',
    contentType: 'application/json',
    success: async function (cart) {
      await fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true);
      await fetchTemplateCartPageCart(cart, 'cart-template', 'cart_line_form', false);
      closeModalOverLay();
      hideUIBlock();
    },
    error: function () {
      hideUIBlock();
    },
  });
}

function openPreview(e) {
  const elBtnPreview = document.querySelector('#preview-item-cart');
  const elPreview = document.querySelector('#modal-preview');
  const elImg = elPreview.querySelector('img');
  elImg.setAttribute('src', e.dataset.previewImg);
  elPreview.classList.remove('wp-hidden');
}

function closeModalPreview() {
  const elPreview = document.querySelector('#modal-preview');
  elPreview.classList.add('wp-hidden');
}

function callAPIUpdateCartPageCart(qty, itemId, elementIdToReload) {
  showUIBlock();
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({
      id: itemId,
      quantity: qty,
    }),
    dataType: 'json',
    contentType: 'application/json',
    success: async function (cart) {
      await fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true);
      await fetchTemplateCartPageCart(cart, 'cart-template', 'cart_line_form', false);
      closeModalOverLay();
      hideUIBlock();
    },
    error: function () {
      hideUIBlock();
    },
  });
}

function fetchTemplateCartPageCart(cart, cart_template, cart_id, is_current_element) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `/?section_id=${cart_template}`,
      success: function (data) {
        // Bundles render collapsed by default — remember which ones the user expanded.
        const expandedKeys = new Set();
        $(`#${cart_id} [data-bundle-line]`).each(function () {
          const btn = this.querySelector('[data-bundle-toggle]');
          if (btn && btn.getAttribute('aria-expanded') === 'true') {
            expandedKeys.add(String(this.getAttribute('data-bundle-key')));
          }
        });

        const $data = $(data);
        const onCartPage = !!document.getElementById('cart_line_form') || /\/cart\/?$/.test(location.pathname);
        if (onCartPage) {
          $data.find('#cart_form').remove();
        }

        if (is_current_element) {
          const newSection = $data.html();
          $(`#${cart_id}`)?.replaceWith(newSection);
        } else {
          const newSection = $data.find(`#${cart_id}`).html();
          $(`#${cart_id}`)?.html(newSection);
        }

        applyExpandedBundleState(cart_id, expandedKeys);

        const pieceCountFromSection = parsePieceCountFromHtml(data);
        updateCartCountDisplays(cart, {
          pieceCount: pieceCountFromSection != null ? pieceCountFromSection : getCartPieceCount(cart),
        });
        if (cart?.item_count == 0) {
          $('.wp-countdown')?.remove();
        }

        resolve();
      },
      error: function (err) {
        console.error(err);
        reject(err);
      },
    });
  });
}

function reloadCartNumber() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    contentType: 'application/json',
    success: function (cart) {
      fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true);
    },
    error: function () { },
  });
}

function applyExpandedBundleState(containerId, expandedKeys) {
  if (!expandedKeys || !expandedKeys.size) return;
  $(`#${containerId} [data-bundle-line]`).each(function () {
    const key = String(this.getAttribute('data-bundle-key'));
    if (!expandedKeys.has(key)) return;
    const btn = this.querySelector('[data-bundle-toggle]');
    const ul = this.querySelector('ul.bundle-components');
    if (!btn || !ul) return;
    btn.setAttribute('aria-expanded', 'true');
    const savedTransition = ul.style.transition;
    ul.style.transition = 'none';
    ul.style.maxHeight = 'none';
    ul.style.opacity = '1';
    ul.style.marginTop = '';
    requestAnimationFrame(function () {
      ul.style.transition = savedTransition;
    });
    const label = btn.querySelector('.bundle-toggle__label');
    const chevron = btn.querySelector('.bundle-toggle__chevron');
    if (label) label.textContent = btn.getAttribute('data-label-hide') || 'Hide add-ons';
    if (chevron) chevron.style.transform = 'rotate(0deg)';
    const summary = this.querySelector('[data-bundle-summary]');
    if (summary) summary.style.display = 'none';
  });
}

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-bundle-toggle]');
  if (!toggle) return;

  const targetId = toggle.getAttribute('data-bundle-toggle');
  const list = document.getElementById(targetId);
  if (!list) return;

  const isCollapsing = toggle.getAttribute('aria-expanded') !== 'false';
  toggle.setAttribute('aria-expanded', String(!isCollapsing));

  if (isCollapsing) {
    list.style.maxHeight = list.scrollHeight + 'px';
    requestAnimationFrame(function () {
      list.style.maxHeight = '0px';
      list.style.opacity = '0';
      list.style.marginTop = '0px';
    });
  } else {
    list.style.maxHeight = list.scrollHeight + 'px';
    list.style.opacity = '1';
    list.style.marginTop = '';
    list.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'max-height') return;
      list.style.maxHeight = 'none';
      list.removeEventListener('transitionend', handler);
    });
  }

  const label = toggle.querySelector('.bundle-toggle__label');
  const chevron = toggle.querySelector('.bundle-toggle__chevron');
  const bundleLine = toggle.closest('[data-bundle-line]');

  const summary = bundleLine && bundleLine.querySelector('[data-bundle-summary]');
  if (summary) {
    summary.style.display = isCollapsing ? '' : 'none';
  }

  if (label) {
    label.textContent = isCollapsing
      ? toggle.getAttribute('data-label-show') || 'Show add-ons'
      : toggle.getAttribute('data-label-hide') || 'Hide add-ons';
  }
  if (chevron) {
    chevron.style.transform = isCollapsing ? 'rotate(180deg)' : 'rotate(0deg)';
  }
});

function closeModalOverLay () {
  $(document).ready(function () {
    var $overlayRemove = $('#modal-remove-cart');
    var $overlayPreview = $('#modal-preview');

    $overlayRemove.on('click', function (event) {
      if (event.target === $overlayRemove[0]) {
        closeModalRemove();
      }
    });

    $overlayPreview.on('click', function (event) {
      if (event.target === $overlayPreview[0]) {
        closeModalPreview();
      }
    });
});
}
